import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ roles, children }) => {
  const currentUser = JSON.parse(sessionStorage.getItem("token"));

  if (!currentUser) {
    // Not logged in, redirect to login
    return <Navigate to="/signin" replace />;
  }

  const userRoles = currentUser.userRoles.map(r => r.roleName);
  const hasAccess = roles ? roles.some(role => userRoles.includes(role)) : true;

  if (!hasAccess) {
    // Role not authorized, redirect to home
    return <Navigate to="/" replace />;
  }

  return children; // Render the protected component
};

export default PrivateRoute;
